import React, { useMemo, useRef, useState } from "react"
import { isEmpty } from "lodash"
import "./_style.scss"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import classNames from "classnames"

// Swiper
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Pagination, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"

// Atoms
import HeroContent from "§/src/components/atoms/content/hero-content"
import ButtonEdgeRounded from "§/src/components/atoms/buttons/button-edge-rounded"

const Hero = props => {
  const pageHero = props.data
  const heroId = useMemo(() => "hero-" + Math.floor(Math.random() * 9999), [])
  const totalSlides = pageHero.length
  const [index, setIndex] = useState(1)
  const [swiperRef, setSwiperRef] = useState(null)

  // if (typeof window === "undefined") {
  //   console.info(`###### HERO RENDERED WITH ${totalSlides} SLIDES! ######`)
  // }

  return !isEmpty(pageHero) ? (
    <div comp="hero" className="pb-5">
      <Swiper
        onSwiper={setSwiperRef}
        onSlideChange={swiper => {
          setIndex(swiper.realIndex + 1)
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: true,
        }}
        slidesPerView={1}
        spaceBetween={0}
        loop={pageHero?.length === 1 ? false : true}
        watchOverflow={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="hero-swiper"
        id={heroId}
      >
        {pageHero.map((heroSlide, pageIndex) => {
          return (
            <SwiperSlide key={pageIndex}>
              {heroSlide?.image && (
                <GatsbyImage
                  className="sw-image d-none d-sm-block w-100"
                  image={getImage(heroSlide.image)}
                  objectFit="cover"
                  objectPosition="right center"
                  alt={heroSlide.image?.altText || ''}
                />
              )}

              {heroSlide?.imageMobile && (
                <GatsbyImage
                  className="sw-image d-sm-none w-100"
                  image={getImage(heroSlide.imageMobile)}
                  objectFit="cover"
                  objectPosition="center bottom"
                  alt={heroSlide.imageMobile?.altText}
                />
              )}

              <HeroContent
                className="align-items-start hero-content-text"
                data={heroSlide}
              ></HeroContent>
            </SwiperSlide>
          )
        })}

        {totalSlides > 1 && (
          <div className="sw-navigation">
            <ButtonEdgeRounded
              id={heroId + "-nav-prev"}
              dir="start"
              onClick={() => swiperRef.slidePrev()}
            ></ButtonEdgeRounded>
            <ButtonEdgeRounded
              id={heroId + "-nav-next"}
              dir="end"
              onClick={() => swiperRef.slideNext()}
            ></ButtonEdgeRounded>
          </div>
        )}
      </Swiper>

      {totalSlides > 1 && (
        <div className="swiper-main-pagination position-relative pt-3">
          <div
            id={`${heroId}-pagination`}
            className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"
          >
            {pageHero.map((elem, i) => (
              <span
                key={i}
                className={classNames("swiper-pagination-bullet", {
                  "spinner-border": i + 1 === index,
                  "border-dark": i + 1 === index,
                })}
                onClick={() => swiperRef.slideTo(i)}
              ></span>
            ))}
          </div>
          <div id={`${heroId}-fraction`} className="swiper-fraction">
            <span className="current">{index}</span>
            <span className="separator"> - </span>
            <span className="total">{totalSlides}</span>
          </div>
        </div>
      )}
    </div>
  ) : (
    ""
  )
}

export default Hero
